function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKioskG(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 48 48",
    id: "svg3",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fill: "#747676",
    fillRule: "evenodd",
    d: "m 41.25,30 h -21 V 7.076087 C 20.25,4.4217391 21.195,2.25 22.35,2.25 h 16.8 c 1.155,0 2.1,2.1717391 2.1,4.826087 z M 39.397059,28.5 H 22.102941 c -0.315,0 -0.52185,-0.482619 -0.525,-1.206522 L 21.485294,6 c -0.0031,-0.723903 0.21,-1.2065218 0.525,-1.2065218 h 17.479412 c 0.315,0 0.52815,0.4826188 0.525,1.2065218 l -0.09265,21.293478 c -0.0031,0.723903 -0.21,1.206522 -0.525,1.206522 z",
    id: "path1",
    style: {
      strokeWidth: 0.795879
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#747676",
    fillRule: "evenodd",
    d: "M 17.264977,30 H 3.7350233 V 15.130435 C 3.7350233,13.408697 4.3438711,12 5.0880185,12 H 15.911982 c 0.744147,0 1.352995,1.408697 1.352995,3.130435 z M 16.071158,29.027027 H 4.9288426 c -0.2029493,0 -0.3362194,-0.31305 -0.3382489,-0.782609 L 4.5309028,14.432432 c -0.00199,-0.469557 0.1352995,-0.782607 0.3382488,-0.782607 H 16.130848 c 0.202949,0 0.340279,0.31305 0.338249,0.782607 l -0.0597,13.811986 c -0.002,0.469559 -0.1353,0.782609 -0.338249,0.782609 z",
    id: "path1-5",
    style: {
      strokeWidth: 0.514506
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#747676",
    fillRule: "evenodd",
    d: "M 37.78125,26.25 H 23.71875 C 23.4375,26.25 23.25,25.73 23.25,24.95 V 8.0500003 c 0,-0.78 0.1875,-1.3000006 0.46875,-1.3000006 h 14.0625 c 0.28125,0 0.46875,0.5200006 0.46875,1.3000006 V 24.95 c 0,0.78 -0.1875,1.3 -0.46875,1.3 z M 32.25,21 h -3 v -3 h -3 v -3 h 3 v -3 h 3 v 3 h 3 v 3 h -3 v 3 z",
    id: "path2",
    style: {
      strokeWidth: 0.780623
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#747676",
    d: "M 14.693422,18.75 H 6.3065776 c -0.1677369,0 -0.2795615,-0.1 -0.2795615,-0.25 v -3.25 c 0,-0.15 0.1118246,-0.25 0.2795615,-0.25 h 8.3868444 c 0.167736,0 0.279561,0.1 0.279561,0.25 v 3.25 c 0,0.15 -0.111825,0.25 -0.279561,0.25 z",
    id: "path2-5",
    style: {
      strokeWidth: 0.264368
    }
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#747676",
    fillRule: "evenodd",
    d: "m 37.5,41.25 h -30 c -2.0625,0 -3.75,-1.755 -3.75,-3.9 V 31.5 h 37.5 v 5.85 c 0,2.145 -1.6875,3.9 -3.75,3.9 z M 25.3125,34.425 h 11.25 v 1.95 h -11.25 z m -16.875,0 h 11.25 v 1.95 h -11.25 z m 8.4375,1.95 c 0,1.0725 -1.21875,1.95 -2.8125,1.95 -1.59375,0 -2.8125,-0.8775 -2.8125,-1.95 z",
    id: "path3",
    style: {
      strokeWidth: 0.956066
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKioskG);
export default __webpack_public_path__ + "static/media/kioskG.e55060c434268d426012454dff917845.svg";
export { ForwardRef as ReactComponent };